'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'

interface NumberInfographicsData {
  headline_H2?: string
  headline_h2?: string
  headline?: string
  description?: string | any
  number_block?: Array<{
    id?: number
    title?: string
    description?: string
  }>
  // Старый формат для обратной совместимости
  metrics?: Array<{
    value?: string
    description?: string
  }>
}

interface NumberInfographicsProps {
  data: NumberInfographicsData
}

const NumberInfographics: React.FC<NumberInfographicsProps> = ({ data }) => {
  const processedHeadline = data.headline ? processStrapiTextTags(data.headline) : ''
  const processedDescription = data.description 
    ? (typeof data.description === 'string' 
        ? processStrapiTextTags(data.description)
        : String(data.description))
    : ''

  // Обрабатываем number_block (новый формат) или metrics (старый формат)
  let metrics: Array<{ value: string; description: string }> = []
  
  if (data.number_block && data.number_block.length > 0) {
    // Новый формат: number_block с title и description
    metrics = data.number_block
      .filter(item => item.title && item.description)
      .map(item => ({
        value: item.title || '',
        description: item.description || ''
      }))
  } else if (data.metrics && data.metrics.length > 0) {
    // Старый формат: metrics с value и description
    metrics = data.metrics
      .filter(metric => metric.value && metric.description)
      .map(metric => ({
        value: metric.value!,
        description: metric.description!
      }))
  }

  // Не возвращаем null, если есть хотя бы заголовок, описание или метрики
  if (metrics.length === 0 && !processedHeadline && !processedDescription) {
    return null
  }

  return (
    <section className={styles.numberInfographics}>
      {(data.headline_H2 || data.headline_h2) && (
        <div className={styles.subtitle}>
          {data.headline_H2 || data.headline_h2}
        </div>
      )}
      
      {processedHeadline && (
        <h2 
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: processedHeadline }}
        />
      )}

      {processedDescription && (
        <div 
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: processedDescription }}
        />
      )}

      {metrics.length > 0 && (
        <div className={styles.metrics}>
          {metrics.map((metric, index) => (
            <div key={index} className={styles.metric}>
              <div className={styles.metricValue}>{metric.value}</div>
              <div className={styles.metricDescription}>{metric.description}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

NumberInfographics.displayName = 'NumberInfographics'

export default NumberInfographics

